// src/Components/Deactivation.jsx

import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import classes from "./Deactivation.module.css";

const Deactivation = () => {
  const navigate = useNavigate();

  const handleConfirm = async () => {
    const msisdn = Cookies.get("msisdn");
    const serviceName = "Zeropoint";

    if (!msisdn) {
      toast.error("Phone number is required.");
      return;
    }

    try {
      const response = await fetch("/deactivation", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ msisdn, serviceName }),
      });

      const res = await response.json();
      if (res.code === 0) {
        Cookies.remove("msisdn");
        Cookies.remove("status");
        toast.success("Deactivated!");
        setTimeout(() => {
          navigate("/subscribe");
        }, 1500);
      } else {
        toast.error(res.message || "Something Went Wrong");
      }
    } catch (error) {
      toast.error("Something Went Wrong. Please try again.");
    }
  };

  return (
    <div className={classes.pageCenter}>
      <div className={classes.deactivateModal}>
        <h3>Do you really want to deactivate?</h3>
        <div className={classes.modalButtons}>
          <button onClick={handleConfirm} className={classes.yesBtn}>
            Yes
          </button>
          <button onClick={() => navigate("/")} className={classes.noBtn}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default Deactivation;
